import useGetMediaLocation from "../hooks/useGetMediaLocation"


export default function Image ({ cue }) {
  const mediaLocation = useGetMediaLocation()
  
  return (
    <div
    style={{
      backgroundImage: cue.imageFromUrl ? `url(${cue.url})` : `url(${mediaLocation}${
        cue.filename
      })`,
      backgroundRepeat: "no-repeat",
      backgroundSize: cue.backgroundFit || "cover",
      // filter: "contrast(90%)",

      backgroundPosition: "center",
    }}
    className={`image_key flex
      w-screen
      h-screen
      
    `}
  >
    {cue.body}
  </div>
  )
}